import { DashboardGridCardActions } from "@/components/table/DashboardGridCardActions";
import { createActionsColumnDef } from "@/components/table/table-actions-column";
import type { TableRowAction } from "@/components/table/TableRowActionsMenu";
import { ColumnDef } from "@tanstack/react-table";
import { useMemo } from "react";

export type DashboardActionsColumnOptions<T extends { id: string }> = {
  documentType: string;
  onEdit: (row: T) => void;
  publicationStatusField?: keyof T;
  buildAdditionalActions?: (row: T) => TableRowAction[];
};

export function useDashboardActionsColumn<T extends { id: string }>({
  documentType,
  onEdit,
  publicationStatusField,
  buildAdditionalActions,
}: DashboardActionsColumnOptions<T>) {
  return useMemo((): ColumnDef<T, unknown> => {
    return createActionsColumnDef<T>(({ row }) => {
      const item = row.original;
      return (
        <div
          className="flex justify-end"
          onClick={(event) => event.stopPropagation()}
        >
          <DashboardGridCardActions
            documentType={documentType}
            item={item}
            onEdit={onEdit}
            publicationStatusField={publicationStatusField}
            buildAdditionalActions={buildAdditionalActions}
          />
        </div>
      );
    });
  }, [documentType, onEdit, publicationStatusField, buildAdditionalActions]);
}
